import {
    initSlider,
    visibilityItem,
    removeLoading,
    getSliderItemValue
} from './slider-util';

export const initMainSlider = () => {
    const selector = '.main-slider';
    const sliderConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000,
        customPaging: function (slider, i) {
            const sliderItems = slider.$slides.length;
            const sliderItem = slider.$slides[i];
            const altValue = getSliderItemValue(sliderItem);

            if (sliderItems > 1) {
                const wrapperNavSlider = document.querySelector(`${selector}`);
                wrapperNavSlider.classList.add(`item-${sliderItems}`);
            }

            return '<span class="dot">' + altValue + '</span>';
        }
    };

    visibilityItem(selector);
    window.require(['slick'], () => {
        initSlider(selector, sliderConfig);
        removeLoading(selector);
    });
};
